import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import TopSellersRow from 'Components/TopSellers/TopSellersRow';

/**
 * Component to display when there are no hits but we don't want to return
 * a 404 with the NotFound component
 */
function NoResults({ topSellersFilter, pageName }) {
  return (
    <div>
      <Container className="text-center py-3 my-6" style={{ border: '1px solid #ff9800' }}>
        <h2 className="h4">
          <FormattedMessage
            id="noresults.title"
            defaultMessage="There are no {categoryName} available right now."
            values={{
              categoryName: pageName || <FormattedMessage id="noresults.pageNameDefault" defaultMessage="relevant products" />,
            }}
          />
        </h2>
        <p className="mt-2 mb-0">
          <FormattedMessage
            id="noresults.content"
            defaultMessage="Sorry, we do not currently have any {categoryName} available to purchase. Check back soon or check out some of our top selling deals below"
            values={{
              categoryName: pageName || <FormattedMessage id="noresults.pageNameDefault" defaultMessage="relevant products" />,
              homePageLink: <Link to="/" className="text-primary">
                <FormattedMessage id="noresults.homePageLink" defaultMessage="the homepage" />
              </Link>,
            }}
          />
        </p>
      </Container>

      <TopSellersRow topSellersFilter={topSellersFilter} />
    </div>
  );
}

NoResults.propTypes = {
  pageName: PropTypes.string,
  topSellersFilter: PropTypes.string,
};

NoResults.defaultProps = {
  pageName: '',
  topSellersFilter: '',
};

export default NoResults;
